import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';

import Actions from '../action';
import { appConstant, apiUrl } from '@constants';
import { removeSessionVariable } from '@helpers';

export function* registerWorker(action) {
	try {
		const uri = `${appConstant.domain + apiUrl.HEALTH}`;
		yield call(Axios.get, uri);
		const registerURI = `${appConstant.domain + apiUrl.REQUEST_ACCESS}`;
		const res = yield call(Axios.post, registerURI, action.request);
		yield put(Actions.creators.registerSuccess({ ...res.data.messages }));
		removeSessionVariable(appConstant.userData);
	} catch (err) {
		console.log(err);
		console.log(err.data);

		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? 'Something went wrong' : 'Something went wrong';
		message.error(mes);
		yield put(Actions.creators.registerCompleted());
	}
}

export default function* registerWatcher() {
	yield takeEvery(Actions.types.REGISTER_STARTED, registerWorker);
}
